import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { GenericSelectorComponent } from './generic-selector.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { AfterFilterChangeDirectiveModule } from '../../directives/after-filter-change.directive.module';

@NgModule({
    imports: [
        CommonModule,
        DropDownsModule,
        AfterFilterChangeDirectiveModule        
    ],
    declarations: [
        GenericSelectorComponent
    ],
    exports: [
        GenericSelectorComponent
    ]

})
export class GenericSelectorModule {
    static forRoot(): ModuleWithProviders<GenericSelectorModule> {
    return {
        ngModule: GenericSelectorModule,
        providers: [GlobalsService, DQOIService]
    };
}
}
